<template>
    <v-container fluid>
        <v-card>
            <v-toolbar dense flat color="secondary">
                <v-toolbar-title>Uploaded Sales Invoices</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="accent" small text to="/import-sales">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>
            <v-card-text>

                <v-divider></v-divider>

                <v-col cols="12">
                    <span class="style-16">{{ uploadedFile && uploadedFile.name }}</span><br>
                    <span class="style-16">Month: {{ uploadedFile && uploadedFile.month }}</span><br>
                    <span class="style-16">Year: {{ uploadedFile && uploadedFile.year }}</span>
                </v-col>

                <v-col cols="12" class="subtitle-2 text--primary">
                    <!-- start of table -->
                    <v-data-table :mobile-breakpoint="0" :items-per-page="1000" :headers="headers" :items="invoices"
                        :search="search">
                        <!-- action template -->
                        <template v-slot:item.action="{ item }">
                            <v-btn v-if="item.status != 1" :loading="loader" @click="getInvoiceDetails(item.id)"
                                color="primary" text>
                                <v-icon left>mdi-eye</v-icon> More Details
                            </v-btn>
                        </template>
                        <!-- end -->

                        <!-- action template -->
                        <template v-slot:item.DocTotal="{ item }">
                            <span> {{ item.DocTotal | currency }}</span>
                        </template>
                        <!-- end -->

                        <!-- action template -->
                        <template v-slot:item.TotalTaxExc="{ item }">
                            <span> {{ item.TotalTaxExc | currency }}</span>
                        </template>
                        <!-- end -->

                        <!-- action template -->
                        <template v-slot:item.TotalTax="{ item }">
                            <span> {{ item.TotalTax | currency }}</span>
                        </template>
                        <!-- end -->

                        <!-- action template -->
                        <template v-slot:item.date="{ item }">{{ item.date | date }}</template>
                        <!-- end -->
                    </v-data-table>
                    <!-- end -->
                </v-col>

                <!-- snackbar -->
                <snackbar ref="snackbar"></snackbar>
            </v-card-text>
        </v-card>

        <!-- summary dialog -->
        <v-dialog v-model="detailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar flat color="secondary" dense>
                    <v-toolbar-title>
                        <v-btn icon @click.native="detailsDialog = false">
                            <v-icon dark>mdi-keyboard-backspace</v-icon>
                        </v-btn>
                        Invoice Details
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="detailsDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-row justify="center" align="center" class="subtitle-2 text--primary">
                        <v-col cols="8" class="mt-2">
                            <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
                        </v-col>

                        <v-col cols="8" style="margin-top: -15px">
                            <v-data-table :search="search" light :mobile-breakpoint="0" :items-per-page="pageItems"
                                :headers="invoiceHeaders" :items="SaleRows" item-key="id" hide-default-footer>
                                <template v-slot:item.ItemCode="{ item }">
                                    <span style="width: 200px">{{ item.product.ItemCode }}</span>
                                </template>

                                <template v-slot:item.Name="{ item }">
                                    <span style="width: 200px">{{ item.product.Name }}</span>
                                </template>

                                <template v-slot:item.Quantity="{ item }">
                                    {{
                                        item.Quantity
                                    }}
                                </template>

                                <template v-slot:item.Price="{ item }">
                                    <span v-if="item.Price">{{ item.Price | currency }}</span>
                                </template>

                                <template v-slot:item.DiscSum="{ item }">
                                    {{
                                        item.DiscSum
                                    }}
                                </template>

                                <template v-slot:item.LineTotal="{ item }">
                                    {{
                                        item.LineTotal | currency
                                    }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- end -->

    </v-container>
</template>

<script>
export default {
    data() {
        return {
            detailsDialog: false,
            SaleRows: [],
            uploadedFile: {},
            invoices: [],
            blobUrl: null,
            search: null,
            CardCode: null,
            deleteDialog: false,
            searchCustomers: null,
            customers: [],
            docItem: {},
            record: {},
            loader: false,
            importDialog: false,
            pageItems: 2000,
            date: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            menu3: false,
            summaryData: [],
            excelFile: null,
            ObjType: 14,
            title: null,
            invoiceHeaders: [
                { text: "ItemCode", value: "ItemCode" },
                { text: "Product", value: "Name" },
                { text: "Qty", value: "Quantity" },
                { text: "Price", value: "Price" },
                { text: "Total", value: "LineTotal" }
            ],
            headers: [
                { text: "Store / Branch", value: "Store.Name" },
                { text: "Total tax Exc", value: "TotalTaxExc" },
                { text: "Total Tax", value: "TotalTax" },
                { text: "Total Sales", value: "DocTotal" },
                { text: "Date", value: "date" },
                { text: "Action", value: "action" },
            ],
            pendingSales: [],
            totalSales: null,
            returnsData: [],
            TotalReturns: null
        };
    },
    watch: {
        "$route.params.id": {
            handler: "getById",
            immediate: true,
        },
    },
    methods: {
        getById(val) {
            const self = this;
            this.$store.commit("loader", true);
            const url = `/uploaded-file-invoices/${val}`;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.invoices = res.ResponseData.invoices;
                        self.uploadedFile = res.ResponseData.uploadedFile;
                        self.$store.commit("loader", false);
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                        self.$store.commit("loader", false);
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getInvoiceDetails(val) {
            const self = this;
            // get record
            this.$store
                .dispatch("get", `/sales-invoice/${val}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                       self.SaleRows = res.ResponseData.SaleRows;
                       self.detailsDialog = true;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {

    }
};
</script>

<style lang="scss" scoped></style>